import miteeForm from './form-page.vue';


// 为组件添加 install 方法，用于按需引入
miteeForm.install = function (Vue) {
    Vue.component('mitee-from', miteeForm)
}

export default miteeForm